import { SearchOrdersWrapper } from "../../components";

export default function SearchOrdersPage() {
  return (
    <div className="spacer-sm">
      <SearchOrdersWrapper />
    </div>
  );
}
